module.exports = __webpack_public_path__ + "static/img/01.96f9626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour4/01.jpg
// module id = FfD2
// module chunks = 0